import { Component } from 'react'
import { Layout,Typography} from 'antd';
const {  Text } = Typography;
const {  Footer } = Layout;

export default class footer extends Component {
  render() {
    return (
        <Footer style={{ textAlign: 'center', background: '#f0f2f5' }}>
            <Text type="secondary">
              © 2025 ATAL · Contact method: AWS_ICBT_Marketplace@atal.com
            </Text>
        </Footer>
    )
  }
}
